import { render, staticRenderFns } from "./wizard-footer.vue?vue&type=template&id=6a19802e&scoped=true"
import script from "./wizard-footer.vue?vue&type=script&lang=js"
export * from "./wizard-footer.vue?vue&type=script&lang=js"
import style0 from "./wizard-footer.vue?vue&type=style&index=0&id=6a19802e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19802e",
  null
  
)

export default component.exports